import styled from "styled-components";

import { PageContainer } from "styles/styled-components";

export const Container = styled(PageContainer)``;
